const styles = {
  filterOutlined: {
    marginTop: 2,
    fontSize: 18,
    position: 'absolute',
    color: '#364150',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: '#364150',
    marginLeft: 25,
  },
  bidTypesLabelWrap: {
    maxWidth: 122,
    marginLeft: 8,
    minWidth: 120,
  },
  divider: { margin: '12px 0' },
};

export default styles;
